import styled from '@emotion/styled';
import NativeSelect from '@/components/comm/NativeSelect';
import {
  breakpointMedium,
  breakpointSmall,
} from '@/constants/breakpoints';
import { colors } from '@/constants/colors';
import { CS_URL } from '@/constants/urls';

const Container = styled.div`
display: flex;
justify-content: space-between;
margin-bottom: 35px;

@media (max-width: ${breakpointMedium}) {
  display: grid;
  justify-items: start;
  row-gap: 36px;
}
`;

const Sites = styled.section`
display: flex;
column-gap: 48px;

@media (max-width: ${breakpointSmall}) {
  display: grid;
  row-gap: 24px;
}
`;

const Site = styled.div`
display: grid;
align-self: start;
`;

const SiteTitle = styled.span`
width: fit-content;
margin-bottom: 12px;
color: ${colors.black};
font-size: 14px;
font-weight: 700;
letter-spacing: 0.15px;
line-height: 24px;

@media (max-width: ${breakpointSmall}) {
  margin-bottom: 8px;
  font-size: 12px;
  line-height: 20px;
}
`;

const SiteLink = styled.a`
width: fit-content;
color: ${colors.brightGrey};
font-size: 14px;
font-weight: 500;
letter-spacing: 0.15px;
line-height: 20px;

&:hover {
  color: ${colors.blue};
}

@media (max-width: ${breakpointMedium}) {
  line-height: 24px;
}

@media (max-width: ${breakpointSmall}) {
  font-size: 12px;
  line-height: 20px;
}
`;

const SiteText = styled.span`
color: ${colors.brightGrey};
font-size: 12px;
font-weight: 500;
letter-spacing: 0.15px;
line-height: 15px;
`;

const FooterSiteMaps = () => (
  <Container>
    <Sites>
      <Site>
        <SiteTitle>서비스</SiteTitle>
        <SiteLink href="https://programmers.co.kr" target="_blank">
          개발자용 프로그래머스
        </SiteLink>
        <SiteLink href="https://business.programmers.co.kr/" target="_blank">
          기업용 프로그래머스
        </SiteLink>
      </Site>
      <Site>
        <SiteTitle>문의</SiteTitle>
        <SiteLink href="https://certi-guide.grepp.co/" target="_blank">
          이용가이드/FAQ
        </SiteLink>
        <SiteLink href={CS_URL} target="_blank">
          1:1 채팅상담
        </SiteLink>
      </Site>
      <Site>
        <SiteTitle>고객센터</SiteTitle>
        <SiteLink href="tel:1533-1886">
          대표번호 1533-1886
        </SiteLink>
        <SiteText>운영시간 : 오전 9시 ~ 오후 6시 (주말 및 공휴일 휴무)</SiteText>
        <SiteText>점심시간 : 오후 12시 ~ 오후 1시</SiteText>
      </Site>
    </Sites>
    <NativeSelect
      height={24}
      fontSize={12}
      value=""
      onChange={({ target: { value } }) => window.open(value, '_blank')}
      padding="2px 18px 2px 6px"
      arrowRight={6}
    >
      <option
        disabled
        value=""
      >패밀리사이트
      </option>
      <option value="https://programmers.co.kr/">프로그래머스</option>
      <option value="https://www.grepp.co/">그렙</option>
      <option value="https://monito.io/">모니토</option>
    </NativeSelect>
  </Container>
);

export default FooterSiteMaps;
